import { render } from "./MainCard.vue?vue&type=template&id=6fc5347f&scoped=true"
import script from "./MainCard.vue?vue&type=script&lang=js"
export * from "./MainCard.vue?vue&type=script&lang=js"

import "./MainCard.vue?vue&type=style&index=0&id=6fc5347f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6fc5347f"

export default script